import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { getClientDetails } from "config";

export default function LogoMain() {
  const clientURL = getClientDetails(window?.location?.origin);

  const logoSrc = clientURL?.Logo || "https://diba6h158qrm3.cloudfront.net/Logo/gnLibLogo.png";
  const libraryName = clientURL?.LibraryName ?? "GN Library";

  return (
    <Stack
      direction={"row"}
      spacing={2}
      height="100%"
      maxHeight={"50px"}
      alignItems="center"
    >
      {logoSrc && (
        <img
          style={{
            height: "120%",
            maxHeight: "50px",
            mixBlendMode: "multiply",
          }}
          src={logoSrc}
          alt={libraryName}
        />
      )}
      {libraryName && (
        <Typography
          variant="h3"
          sx={{
            fontSize: { xs: 18, sm: 20, md: 20, lg: 22 },
          }}
        >
          {libraryName}
        </Typography>
      )}
    </Stack>
  );
}
